import { h, Component, FunctionalComponent } from 'preact';
import { connect } from 'preact-redux';
import { db, storage } from '../../firebase';
import { ApplicationState } from '../../store';
import { POTWState } from '../../store/potw/types';

const style = require('./style.less');

export const POTW: FunctionalComponent<POTWState> = ({url,description,width,height}) => {
    return (url === null ? null : (
        <div class={style.potw}>
            <img src={url} style="width:{ width / 2 } !important;height:{ height / 2} !important" />
            <p>{description}</p>
        </div>
    ));
}

const mapStateToProps = (state:ApplicationState) => state.potw

export default connect(mapStateToProps)(POTW);



// WEBPACK FOOTER //
// ./components/potw/index.tsx